(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('Usuarios', Usuarios);

    Usuarios.$inject = ['$animationsSrv', 'UsuariosService', 'logger', '$location', 'UserInfoService'];

    function Usuarios($animationsSrv, UsuariosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        var PERMISO_ID = 2;

        vm.criteriosBusqueda = {
            nombre: '',
            apellidos: '',
            apellido2: ''
        };

        vm.usuarios = [];
        vm.title = 'Usuarios';
        vm.permisos = UserInfoService.getPermisos(PERMISO_ID);

        vm.goToEdit = function(usuario){
            
            var path = '/editar-usuario/';

            if(usuario){
                $location.path(path + usuario.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.goToChangePassword = function(usuario){
            
            var path = `cambiar-password/${usuario.id}/${usuario.nombre}`;
            
            $location.path(path);
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.clearCriteria = function()
        {
            vm.criteriosBusqueda = {
                nombre: '',
                apellidos: '',
                apellido2: ''
            };
        };

        getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function getAll(){

            const criterios = [
                vm.criteriosBusqueda.nombre === '' ? '0' : vm.criteriosBusqueda.nombre,
                vm.criteriosBusqueda.apellidos === '' ? '0' : vm.criteriosBusqueda.apellidos,
                vm.criteriosBusqueda.apellido2 === '' ? '0' : vm.criteriosBusqueda.apellido2
            ];

            var promise = UsuariosService.getAll(criterios);

            promise
            .then(function(usuarios){
                vm.usuarios = usuarios;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los usuarios.');
                        break;
                }
                
            });
        };

        vm.delete = function(usuario){
            var promise = UsuariosService.remove(usuario);
            
            promise
            .then(function(response){
                vm.usuarios = vm.usuarios.filter(function(u) {
                    return u.id !== usuario.id;
                });
                logger.success('Usuario eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el usuario');
                        break;
                }
                
            });   
        };

    }
})();